export const STORAGE_KEYS = {
  token: "dw_token",
  user: "dw_user",
  store: "dw_store",
  // Bootstrap data pulled from pos/v1/init once per login (categories, table
  // areas) and read from localStorage after that — see AuthContext.ensureSession.
  session: "dw_session",
  // Cached full product catalog (small-store menu path only — see useMenu's
  // 'full' vs 'paginated' source split). Cache-first: Home reads this on mount
  // instead of hitting the network, and only refetches when the waiter taps
  // the reload button. Scoped to a store id stored alongside it, so a login
  // to a different store on the same device doesn't show stale products.
  menu: "dw_menu_cache",
};

// Exact strings denzo-api/denzo-admin use throughout (OrderController@placeOrder
// only special-cases dine_in [store_table_id] and delivery [delivery_address];
// take_away needs neither). Matches denzo-admin's Delivery Options checkboxes
// (components/UI/Form/FormFields.js) so store.delivery_options[value] lines up.
export const ORDER_TYPES = [
  { value: "dine_in", label: "Table" },
  { value: "delivery", label: "Delivery" },
  { value: "take_away", label: "Takeaway" },
];

// order_items.cancel_type — same enum OrderController@cancelOrder validates
// ('cancel_type'=>'required|in:cancel,return,void'), reused here for
// item-level cancellation via placeOrder (status: 2 + cancel_type + cancel_reason).
export const CANCEL_TYPES = [
  { value: "cancel", label: "Cancel" },
  { value: "return", label: "Return" },
  { value: "void", label: "Void" },
];

export const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL || "";
